const products = {
  "products": [
    {
      "id": "suko-billing",
      "title": "Suko Billing",
      "tagline": "Facturación sin complicaciones",
      "landing": true,
      "status": "live",
      "platforms": ["Web", "iOS", "Android"],
      "color": "#D8ECEB",
      "description": "Solución de facturación y gestión financiera diseñada para pymes y autónomos. Crea, envía y gestiona facturas de forma rápida y profesional.",
      "list": [
        "Gestión de clientes",
        "Gestión de productos y servicios",
        "Creación y envío de presupuestos",
        "Creación y envío de facturas",
        "Listas de distribución de facturas"
      ],
      "closeMessage": "Ideal para empresas que buscan automatizar su facturación y gestión financiera. Permitimos mandar los documentos directamente a los clientes. Además pueden añadir el email de sus gestores para que reciban de forma automática las facturas que generen. Actualmente estamos trabajando en añadir la funcionalidad de Verifactu para enviar facturas electrónicas.",
      "image": "",
      "url": "https://billing.suko.space"
    },
    {
      "id": "suko-bookings",
      "title": "Suko Bookings",
      "tagline": "Gestión de reservas inteligente",
      "landing": true,
      "status": "coming-soon",
      "platforms": ["Web", "iOS", "Android"],
      "color": "#C6AEF5",
      "description": "Solución de gestión de reservas y espacios diseñada para pymes y autónomos. Organiza tu agenda, tus recursos y a tu equipo desde un solo lugar.",
      "list": [
        "Gestión de clientes",
        "Gestión de servicios",
        "Gestión de horarios",
        "Gestión de espacios",
        "Gestión de materiales",
        "Gestión de personal"
      ],
      "closeMessage": "Ideal para empresas que buscan automatizar su facturación y gestión financiera. Permitimos mandar los documentos directamente a los clientes. Además pueden añadir el email de sus gestores para que reciban de forma automática las facturas que generen. Actualmente estamos trabajando en añadir la funcionalidad de Verifactu para enviar facturas electrónicas.",
      "image": "",
      "url": "https://bookings.suko.space"
    },
    {
      "id": "suko-shopping",
      "title": "Suko Shopping",
      "tagline": "Compra inteligente, ahorra más",
      "landing": true,
      "status": "coming-soon",
      "platforms": ["Web", "iOS", "Android"],
      "color": "#E7F58E",
      "description": "Herramienta para organizar y optimizar tus compras en el supermercado. Compara precios, gestiona listas y encuentra siempre la mejor opción.",
      "list": [
        "Gestión de listas de compras",
        "Comparación de precios",
        "Gestión de productos"
      ],
      "closeMessage": "Ideal para particulares que buscan organizar sus compras en supermercados con precios más baratos.",
      "image": "",
      "url": "https://shopping.suko.space"
    }
  ]
}

export default products;
